function handleShowcaseSlider() {
  // Select all slide elements
  const slides = Array.from(
    document.querySelectorAll(".showcase-slider__slide")
  );

  if (!slides.length) return;

  // Iterate through each slide
  slides.forEach((slide) => {
    // Select all necessary elements within the slide
    const subTitleElem = slide.querySelector(
      ".showcase-slider__slide-card-header-left h3 + p"
    );
    const reviewUrlElem = slide.querySelector(".is-star-mini-widget");
    const featuredImageElem = slide.querySelector(
      ".showcase-slider__slide-card-image-featured-img"
    );
    const featuredImageUrlElem = slide.querySelector(
      ".showcase-slider__slide-card-image-featured-url"
    );
    const sideShieldToggleElem = slide.querySelector(
      ".showcase-slider__sideshield-switch input[type=checkbox]"
    );
    const priceElem = slide.querySelector(".showcase-slider__price p");
    const sideShieldPriceElem = slide.querySelector(
      ".showcase-slider__slide-card-image-thumbs"
    );
    const atcBtnElem = slide.querySelector(".showcase-slider__atc button");
    const thumbSliders = Array.from(
      slide.querySelectorAll(".showcase-slider__slide-card-image-thumb")
    );
    const frameSizeRadios = Array.from(
      slide.querySelectorAll(
        ".showcase-slider__slide-card-framesize-radio-group input[type=radio]"
      )
    );

    // Check if all necessary elements are present
    if (
      !subTitleElem ||
      !reviewUrlElem ||
      !featuredImageElem ||
      !featuredImageUrlElem ||
      !priceElem ||
      !atcBtnElem ||
      !thumbSliders.length ||
      !frameSizeRadios.length
    )
      return;

    // Initialize state variables
    let isSideShieldEnabled = false;
    let isSideShieldAvailable = sideShieldToggleElem !== null;
    let originalPrice = parseInt(priceElem.textContent.replace("$", ""));
    let currentThumb = thumbSliders.find((thumb) =>
      thumb.classList.contains("is--active")
    );
    let originalFeaturedImage = featuredImageElem.src;
    let currentCheckedFrameSize = null;
    let sideShieldPrice = isSideShieldAvailable
      ? parseInt(sideShieldPriceElem.dataset.sideshieldPrice)
      : 0;
    let sideShieldId = isSideShieldAvailable
      ? sideShieldPriceElem.dataset.sideshieldProductId
      : null;

    // Function to update the featured image based on side shield status
    function updateFeaturedImage() {
      if (isSideShieldAvailable && isSideShieldEnabled && currentThumb) {
        const sideShieldImage = currentThumb.dataset.sideShieldImage;
        if (sideShieldImage) {
          featuredImageElem.src = sideShieldImage;
        }
      } else {
        featuredImageElem.src = originalFeaturedImage;
      }
    }

    // Function to update the Add to Cart button state
    function updateATCButton(isAvailable) {
      atcBtnElem.textContent = isAvailable ? "Quick Add" : "Sold Out";
      atcBtnElem.disabled = !isAvailable;
    }

    // Function to update the price display
    function updatePrice() {
      let totalPrice = originalPrice;
      if (isSideShieldAvailable && isSideShieldEnabled) {
        totalPrice += sideShieldPrice;
      }
      priceElem.textContent = `$${totalPrice}`;
    }

    // Function to update frame size information
    function updateFrameSizeInfo() {
      if (!currentThumb || !currentCheckedFrameSize) return;

      const frameSize = currentCheckedFrameSize.id.split("-")[0];
      let frameSizeAvailable = false;
      let frameSizePrice = "";
      let variantId = "";

      // Determine availability, price, and variant ID based on frame size
      switch (frameSize) {
        case "regular":
          frameSizeAvailable = currentThumb.dataset.regularAvailable === "true";
          frameSizePrice = currentThumb.dataset.regPrice;
          variantId = currentThumb.dataset.regularId;
          break;
        case "narrow":
          frameSizeAvailable = currentThumb.dataset.narrowAvailable === "true";
          frameSizePrice = currentThumb.dataset.narrowPrice;
          variantId = currentThumb.dataset.narrowId;
          break;
        case "xl":
          frameSizeAvailable = currentThumb.dataset.xlAvailable === "true";
          frameSizePrice = currentThumb.dataset.xlPrice;
          variantId = currentThumb.dataset.xlId;
          break;
      }

      // Update price if a new frame size is selected
      if (frameSizePrice) {
        originalPrice = parseInt(frameSizePrice);
        updatePrice();
      }

      updateATCButton(frameSizeAvailable);

      // Update review URL and featured image URL
      const baseUrl = currentThumb.dataset.variantProductUrl.split("?")[0];
      const newUrl = `${baseUrl}?variant=${variantId}${
        isSideShieldEnabled ? "&addons=sideshields" : ""
      }`;
      reviewUrlElem.href = `${newUrl}#pdp-review-section`;
      featuredImageUrlElem.href = newUrl;
    }

    // Function to handle frame size selection
    function updateFrameSizeSelection(selectedRadio) {
      frameSizeRadios.forEach((radio) => {
        radio.checked = radio === selectedRadio;
      });
      currentCheckedFrameSize = selectedRadio;
      updateFrameSizeInfo();
      updateFeaturedImage();
    }

    // Set default frame size to Regular
    const defaultRegularRadio = frameSizeRadios.find((radio) =>
      radio.id.startsWith("regular-")
    );
    if (defaultRegularRadio) {
      updateFrameSizeSelection(defaultRegularRadio);
    }

    // Add event listeners for frame size changes
    frameSizeRadios.forEach((radio) => {
      radio.addEventListener("change", (e) => {
        updateFrameSizeSelection(e.target);
      });
    });

    // Add event listener for side shield toggle if available
    if (isSideShieldAvailable && sideShieldToggleElem) {
      sideShieldToggleElem.addEventListener("change", (e) => {
        isSideShieldEnabled = e.target.checked;
        updatePrice();
        updateFeaturedImage();
        updateUrlWithSideShield(e.target.checked);
        updateFrameSizeInfo();
      });
    }

    // Function to update URL with side shield parameter
    function updateUrlWithSideShield(isChecked) {
      const url = new URL(window.location.href);
      if (isChecked) {
        url.searchParams.set("addons", "sideshields");
      } else {
        url.searchParams.delete("addons");
      }
      // window.history.replaceState({}, "", url.toString());
    }

    // Add event listeners for thumb sliders
    thumbSliders.forEach((thumbSlider) => {
      const titleElem = thumbSlider.dataset.productTitle;
      const thumbImageElem = thumbSlider.querySelector("img");
      const thumbProductUrlElem = thumbSlider.dataset.variantProductUrl;

      if (!titleElem || !thumbImageElem) return;

      thumbSlider.addEventListener("click", () => {
        subTitleElem.innerText = titleElem;
        originalFeaturedImage = thumbImageElem.src;
        featuredImageUrlElem.href = thumbProductUrlElem;

        // Update active thumb slider
        thumbSliders.forEach((ts) => ts.classList.remove("is--active"));
        thumbSlider.classList.add("is--active");
        currentThumb = thumbSlider;

        reviewUrlElem.href = `${thumbProductUrlElem}#pdp-review-section`;

        updateFrameSizeInfo();
        updateFeaturedImage();
      });
    });

    // Add to cart button event
    atcBtnElem.addEventListener("click", async () => {
      if (!currentThumb || !currentCheckedFrameSize) {
        console.error("No variant selected or frame size not chosen");
        return;
      }

      const frameSize = currentCheckedFrameSize.id.split("-")[0];
      const variantId = currentThumb.dataset[`${frameSize}Id`];

      // Create the items array, including the side shield if enabled
      const items =
        isSideShieldAvailable && isSideShieldEnabled
          ? [{ id: variantId }, { id: sideShieldId }]
          : [{ id: variantId }];

      try {
        // This comes from ombraz-utils.js, which is our little library.
        await OmbrazUtils.v2AddToCart(items, { button: atcBtnElem });
      } catch (error) {
        console.error("Error adding to cart:", error);
      }
    });

    // Initial update
    updateFrameSizeInfo();
  });
}

function handleSwiperSlide() {
  const swiperSlide = document.getElementById("showcase-slider");
  const prevButton = document.getElementById("showcase-prev-button");
  const nextButton = document.getElementById("showcase-next-button");
  const slidesWrapper = swiperSlide?.querySelector(".showcase-slider__slides");

  if (!swiperSlide || !prevButton || !nextButton || !slidesWrapper) return;

  const swiper = new Swiper(swiperSlide, {
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    preventClicks: true,
    a11y: false,
    on: {
      init: function () {
        updateNavigationButtons(this);
        updateFadeEffect(this);
      },
      slideChange: function () {
        updateNavigationButtons(this);
        updateFadeEffect(this);
      },
    },
  });

  function updateNavigationButtons(swiper) {
    prevButton.disabled = swiper.isBeginning;
    nextButton.disabled = swiper.isEnd;
  }

  function updateFadeEffect(swiper) {
    if (swiper.isBeginning) {
      slidesWrapper.classList.add("show-fade");
    } else {
      slidesWrapper.classList.remove("show-fade");
    }
  }

  prevButton.addEventListener("click", () => {
    swiper.slidePrev();
  });

  nextButton.addEventListener("click", () => {
    swiper.slideNext();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  handleSwiperSlide();
  handleShowcaseSlider();
});
